<template>
  <div class="ui-content dashboard user-section">
    <v-card class="mx-auto normal-card autohg">
      <div class="user-data">
        <v-row>
          <v-col cols="12" sm="12">
            <div class="show-drop-down">
              <div class="label-data">Select Center</div>
              <div class="field-data">
                <multi-select
                  allText="All Centers"
                  :items="centers"
                  label="select center"
                  :onChange="onCenterchange"
                  widthcss="fix-200"
                ></multi-select>
              </div>
            </div>
            <div class="show-drop-down">
              <div class="label-data">Select Batch</div>
              <div class="field-data">
                <multi-select
                  allText="All Batches"
                  :items="batches"
                  label="select batch"
                  :onChange="onBatchSelect"
                  widthcss="fix-200"
                ></multi-select>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td class="check-50">
                  <div class="check-cust">
                    <v-checkbox v-model="item.checked"></v-checkbox>
                  </div>
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.related_user_name }}</td>
                <td>{{ item.related_user_email }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left">
        <v-btn
          :loading="loading"
          @click="requestApproveOrDisapproveUser(1)"
          class="right-btn cust-btn"
          color="primary"
          >Approve</v-btn
        >
        <v-btn
          :loading="loading"
          @click="requestApproveOrDisapproveUser(-1)"
          class="right-btn cust-btn"
          color="primary"
          >Disapprove</v-btn
        >
      </div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
const user = JSON.parse(sessionStorage.getItem("user"));
import constants from "@/utils/constants.js";

export default {
  name: "UsersParents",
  props: ["updateRouteDetails"],
  data() {
    return {
      batches: [],
      centers: [],
      selectedCenterId: null,
      selectedBatch: null,
      loading: false,

      items: [],
      orderBy: {
        field: "name",
        order: "ASC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      gotAllTests: false,
      isLoadingFirstTime: true,
    };
  },
  methods: {
    ...mapActions({
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
      approveOrDisapproveUser: "userStore/approveOrDisapproveUser",
    }),
    onBatchSelect(selectedBatch) {
      this.selectedBatch = selectedBatch;
      this.items = [];
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
      this.selectedBatch = [];
      this.items = [];
    },
    requestApproveOrDisapproveUser(status) {
      let user_ids = [];
      if (this.items && this.items.length) {
        user_ids = this.items.filter((i) => i.checked).map((u) => u.id);
        if (!user_ids || user_ids.length < 1) {
          return this.$toasted.error(`Select atleast one user`);
        }
        let reqData = {
          role_id: this.roleIds.PA,
          status: status,
          user_ids: user_ids,
        };
        this.loading = true;
        this.approveOrDisapproveUser(reqData)
          .then((response) => {
            this.loading = false;
            this.requesGetSelfSignedUpUsers();
            this.$toasted.success(`Success\n${response.message}`, {
              icon: "check_circle",
            });
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
    resetPage() {
      this.currentPage = 1;
      this.updateCurrentPageInSession(1);
    },
    onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        if (!this.isLoadingFirstTime) this.resetPage();
        this.updateRouteDetails({ type: "centerIds", data: { centerIds } });
        this.$root.showLoader = true;
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            // this.$root.showLoader = false;
            if (response && response.list && response.list.length) {
              if (this.selectedBatch) {
                let arr = [];
                this.selectedBatch.map((xx, i) => {
                  let isExist = false;
                  response.list.map((x) => {
                    if (!isExist) {
                      isExist = xx === x.id;
                    }
                  });
                  if (!isExist) {
                    arr.push(xx);
                  }
                });
                if (arr && arr.length) {
                  arr.map((xx) => {
                    this.selectedBatch.splice(
                      this.selectedBatch.indexOf(xx),
                      1
                    );
                  });
                }
              }
              let batchIds = [];
              this.batches = response.list.map((x) => {
                batchIds.push(x.id);
                let c = {};
                c.text = x.name;
                c.value = x.id;
                c.checked =
                  this.selectedBatch && this.selectedBatch.indexOf(x.id) !== -1;
                return c;
              });
              // if (!this.gotAllTests) {
              //     this.gotAllTests = true;
              //     this.batches = this.batches.map(batch => {
              //         batch.checked = true;
              //         return batch;
              //     });
              //     this.selectedBatch = batchIds;
              // }
            } else {
              this.batches = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this.getCentersByUser()
        .then((response) => {
          let centerIds = [];
          // this.$root.showLoader = false;
          this.centers = response.map((x) => {
            centerIds.push(x.id);
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = this.selectedCenterId.includes(x.id);
            return c;
          });
          // this.onCenterSelect(centerIds);
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requesGetSelfSignedUpUsers() {
      // if(!this.selectedBatch || this.selectedBatch.length == 0) return;
      let reqData = {
        role_id: this.roleIds.PA,
        is_approved: 0,
        active: 1,
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      if (
        this.selectedBatch &&
        this.selectedBatch.length > 0 &&
        this.batches.length != this.selectedBatch.length
      ) {
        reqData.batch_ids = this.selectedBatch;
      }
      if (
        this.selectedCenterId &&
        this.selectedCenterId.length > 0 &&
        this.centers.length != this.selectedCenterId.length
      ) {
        reqData.center_ids = this.selectedCenterId;
      }
      this.getSelfSignedUpUsers(reqData)
        .then((response) => {
          this.isLoadedFirstTime = false;
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((u) => {
            u.checked = false;
            return u;
          });
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
        if (e.data) {
          this.items = this.items.map((u) => {
            u.checked = e.data.checked;
            return u;
          });
        }
      }
    },
    onSortChange(e) {
      this.requesGetSelfSignedUpUsers();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requesGetSelfSignedUpUsers();
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
      if (!crd && !crd.tabDetails[crd.selectedTab].centerIds) {
        this.requesGetSelfSignedUpUsers();
      }
    },
  },
  mounted() {
    this.defaultData();
  },
  watch: {
    selectedCenterId(val) {
      if (val) {
        this.onCenterSelect(val);
        // this.requesGetSelfSignedUpUsers();
      }
    },
    selectedBatch(val) {
      if (!this.isLoadingFirstTime) this.resetPage();
      this.updateRouteDetails({ type: "batchIds", data: { batchIds: val } });
      this.requesGetSelfSignedUpUsers();
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "",
          value: "check",
          type: "check",
          class: "check-50",
          checked: this.isAllUserSelected,
        },
        { text: "Name", value: "name" },
        { text: "Email Id", value: "email" },
        { text: "Student Name", value: "related_user_name" },
        { text: "Student Email Id", value: "related_user_email" },
      ];
    },
    isAllUserSelected() {
      if (this.items && this.items.length) {
        let tmpArry = this.items.filter((x) => x.checked);
        if (tmpArry) {
          return tmpArry.length === this.items.length;
        }
      }
      return false;
    },
  },
};
</script>
